export default __webpack_public_path__ + "dist/media/Opportunities.5cb72a0f.png";